/* FleetPro Filters Module v1.0.0 - fp-oem-lookup.js
   THE cross-reference lookup. One normalizer, one index loader, one place.

   Exposes window.FPOEM:
     FPOEM.brandRe(list)          build the brand-strip regex from a brand list
     FPOEM.normOem(s, re)         a raw term -> an index key
     FPOEM.load(url)              fetch + cache the index (one in-flight promise)
     FPOEM.lookup(raw, url)       -> Promise<{key, hits:[{handle, sku, title}]}>
     FPOEM.looksLikePartNumber(s) cheap guard: is this worth a lookup at all

   WHY THIS FILE EXISTS
   --------------------
   normOem/brandRe used to be hand-copied into fp-hero.js AND
   sections/fp-vin-search.liquid, each with a comment saying "keep in sync with
   fitlib._OEM_BRANDS". That contract was never violated - the copies agreed with
   each other perfectly, and all of them were blind to 46% of the catalogue,
   because sync discipline only checks that copies MATCH, never that the answer
   is RIGHT. Adding a third copy for the header search would have rebuilt the
   exact bug that was just fixed. So the definition moved here and the call sites
   consume it.

   The 186-brand list is not in this file either - it ships INSIDE
   fp-oem-index.json as `brands`, so there is nothing to keep in sync at all. The
   literal below is only a fallback for an index served from cache before that
   field existed. */
(function () {
  if (window.FPOEM) return;

  var fp = (window.fpFilters = window.fpFilters || { version: '1.0.0', loaded: {} });
  fp.loaded.oemLookup = '1.0.0';

  var OEM_BRANDS = /^(volvo|freightliner|kenworth|peterbilt|mack|paccar|navistar|international|detroit(\s+diesel)?|grote|truck[- ]?lite|trucklite|bendix|haldex|meritor|wabco|dorman|automann|united\s+pacific|newstar|s&s|alliance|abp)\s+/i;

  function brandRe(list) {
    if (!list || !list.length) return OEM_BRANDS;
    var alts = list.map(function (b) {
      return b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
    }).sort(function (a, b) { return b.length - a.length; });
    try { return new RegExp('^(' + alts.join('|') + ')\\s+', 'i'); } catch (e) { return OEM_BRANDS; }
  }

  function normOem(s, re) {
    return String(s || '').trim().replace(re || OEM_BRANDS, '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }

  /* Cheap pre-filter so an ordinary word search never pays for the index fetch.
     A part number has a digit and no spaces once a brand prefix is removed.
     "brake drum" must not trigger a lookup; "Cummins 3690067" must. */
  function looksLikePartNumber(s) {
    var k = normOem(s, null);
    if (k.length < 4 || k.length > 32) return false;
    if (!/\d/.test(k)) return false;
    var words = String(s || '').trim().split(/\s+/);
    return words.length <= 3;
  }

  var cache = null, inflight = null;
  function load(url) {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) { cache = d; inflight = null; return d; })
      .catch(function (e) { inflight = null; throw e; });
    return inflight;
  }

  function lookup(raw, url) {
    return load(url).then(function (d) {
      var key = normOem(raw, brandRe(d.brands));
      var idx = (d.entries || {})[key] || [];
      return {
        key: key,
        hits: idx.map(function (i) {
          var row = (d.products || [])[i] || [];
          return { handle: row[0], sku: row[1], title: row[2] };
        }).filter(function (h) { return h.handle; })
      };
    });
  }

  window.FPOEM = {
    brandRe: brandRe,
    normOem: normOem,
    load: load,
    lookup: lookup,
    looksLikePartNumber: looksLikePartNumber,
    FALLBACK_BRANDS: OEM_BRANDS
  };
})();
